export default "__VITE_ASSET__0fbb65e1__"